import { render } from "./tab-booking-cancelled.vue?vue&type=template&id=521fbc02&scoped=true&ts=true"
import script from "./tab-booking-cancelled.vue?vue&type=script&lang=ts"
export * from "./tab-booking-cancelled.vue?vue&type=script&lang=ts"

import "./tab-booking-cancelled.vue?vue&type=style&index=0&id=521fbc02&scoped=true&lang=css"
import "./tab-booking-cancelled.vue?vue&type=style&index=1&id=521fbc02&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-521fbc02"]])

export default __exports__